export default __webpack_public_path__ + "static/media/careadmin_patient_icon.8a7e11f5.svg";